/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { PopupContext } from '../Common/Custompopups';

interface Istep {
  stepNumber: number;
  stepName: string;
  isCompleted: boolean;
  isCurrentStep: boolean;
}

export function ApplicationSteps() {
  const popupContext = useContext(PopupContext);
  const authzToken = useAppSelector(
    (state: RootState) => state.authz.AuthzInfo,
  );
  const steps: Array<Istep> = [
    {
      stepNumber: 1,
      stepName: 'Contact Details',
      isCompleted: popupContext.statusCode
        ? popupContext.statusCode >= 42 && authzToken
        : false,
      isCurrentStep:
        popupContext.statusCode === undefined ||
        popupContext.statusCode === 41 ||
        !authzToken,
    },
    {
      stepNumber: 2,
      stepName: 'Personal Details',
      isCompleted: popupContext.statusCode
        ? popupContext.statusCode >= 44 && authzToken
        : false,
      isCurrentStep: authzToken
        ? popupContext.statusCode === 42 ||
          popupContext.statusCode === 43
        : false,
    },
    {
      stepNumber: 3,
      stepName: 'Address Details',
      isCompleted: popupContext.statusCode
        ? popupContext.statusCode >= 46 && authzToken
        : false,
      isCurrentStep: authzToken
        ? popupContext.statusCode === 44 ||
          popupContext.statusCode === 45
        : false,
    },
    {
      stepNumber: 4,
      stepName: 'Credit Assessment',
      isCompleted: popupContext.statusCode
        ? popupContext.statusCode >= 48 &&
          popupContext.statusCode < 56 &&
          popupContext.statusCode !== 53 &&
          authzToken
        : false,
      isCurrentStep: authzToken
        ? popupContext.statusCode === 46 ||
          popupContext.statusCode === 47
        : false,
    },
  ];

  return (
    <div className="flex md:ml-10 w-full md:w-auto mt-8 sm:mt-0 justify-center px-5 md:px-0 ">
      {steps.map((step) => {
        return (
          <div key={step.stepName} className="w-full ">
            <p className=" text-xs sm:text-sm    text-gray-500 w-10 sm:w-auto">
              {step.stepName}
            </p>
            <div className="flex items-center w-full ">
              <div
                className={`h-6 w-6 sm:h-8 sm:w-8  rounded-full flex justify-center text-normal items-center font-semibold ${
                  step.isCompleted && authzToken
                    ? 'bg-confirmbtn-500 text-black'
                    : `${
                        step.isCurrentStep
                          ? 'bg-white text-black'
                          : 'bg-circlebg-100 text-circlestroke-100'
                      }  border-2  border-circlestroke-100 `
                }`}
              >
                {step.stepNumber}
              </div>
              {steps.length !== step.stepNumber && (
                <div
                  className={`w-10 sm:w-24 h-1 border-0.5 border-circlestroke-100 flex-grow ${
                    step.isCompleted && authzToken
                      ? 'bg-confirmbtn-500'
                      : 'bg-circlebg-100'
                  } mx-1 rounded-md `}
                >
                  {' '}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
